import React from "react";
import { Link } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";

import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles(theme => ({
  root: {
    textAlign: "center",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    lineHeight: "1.5",
    margin: "0 auto",
    maxWidth: "900px",
    [theme.breakpoints.down("sm")]: {
      paddingBottom: theme.spacing(2),
      paddingTop: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  },
  important: {
    marginBottom: theme.spacing(3)
  }
}));

function Note({ locale }) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      <h2>{t("order.important.header")}</h2>
      <div className={classes.important}>
        <Trans i18nKey={"order.important.text"}>
          text <b>text</b> text
        </Trans>
      </div>
      <a
        href={`https://www.dako.eu/${locale}/`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Button
          variant="contained"
          // color="primary"
          // onClick={handleAddProductClick}
        >
          {t("order.important.cta")}
        </Button>
      </a>
    </div>
  );
}

export default Note;
